const elemContentOverview = document.querySelectorAll('.wt_LinkList');
window.fireOnVisible(elemContentOverview, async () => {
    await import('./assets/css/wt_LinkList.scss');
});
